import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useCallback } from 'react';
import CallToConfirmActionDialog from './CallToConfirmActionDialog';

const CallToDigitalInvoiceConfirmActionDialog = ({
  open,
  title,
  onAccept = () => {},
  onDeny = () => {},
  acceptText = 'Aceptar',
  denyText = 'Cancelar'
}) => {
  const classes = useStyles();

  const renderDigitalInvoiceConfirmContent = useCallback(() => {
    return (
      <>
        <Typography paragraph className={classes.dialogText}>
          Activando el envío de factura por este medio tendrás los siguientes
          beneficios: <br />
        </Typography>
        <ul className={classes.dialogItemText}>
          <li>Recibir tu factura vía whatsapp, SMS y/o correo.</li>
          <li>Realizar pagos en línea fácilmente.</li>
          <li>Proteger tu información personal. </li>
          <li>
            Cuidar el medioambiente y contribuir a un planeta más sostenible.
          </li>
        </ul>
      </>
    );
  }, [classes.dialogText, classes.dialogItemText]);

  return (
    <CallToConfirmActionDialog
      open={open}
      onAccept={onAccept}
      onDeny={onDeny}
      acceptText={acceptText}
      denyText={denyText}
      content={renderDigitalInvoiceConfirmContent}
      title={title}
    />
  );
};

const useStyles = makeStyles(() => ({
  dialogText: {
    fontSize: 14
  },
  dialogItemText: {
    fontSize: 14,
    paddingLeft: '24px'
  }
}));

export default CallToDigitalInvoiceConfirmActionDialog;
